import React from 'react'
import AllRoutes from './routes/Routes'
import DocumentTitle from './components/DocumentTitle'

// styles
import 'gridjs/dist/theme/mermaid.min.css'
import './assets/scss/app.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'react-phone-number-input/style.css'
import { ToastContainer } from 'react-toastify'
import 'ag-grid-community/styles/ag-grid.css' // Core grid CSS
import 'ag-grid-community/styles/ag-theme-quartz.css' // Quartz theme CSS
import 'react-quill-new/dist/quill.snow.css'
 
import { createPortal } from 'react-dom';

const App = () => {
	const toastRoot = document.getElementById('toast-root')
	return (
		<React.Fragment>
			<DocumentTitle />
			<AllRoutes />
			{toastRoot && createPortal(<ToastContainer />, toastRoot)}
		</React.Fragment>
	)
}

export default App
